const initialFilterState = {
  start_time: "",
  end_time: "",
  filterValueKey: "ALL",
};

const reducer = (state = initialFilterState, action) => {
  if (action.type === "quizReportsFilter") {
    return action.payload;
  } else {
    return state;
  }
};

export default reducer;
